import { render, staticRenderFns } from "./TiemposAtencion.vue?vue&type=template&id=94384486"
import script from "./TiemposAtencion.vue?vue&type=script&lang=js"
export * from "./TiemposAtencion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports